import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Dark_Gray_Btn.css";

const Dark_Gray_Btn = ({ btnText, type, onClick }) => {
  return (
    <button
      className="Dark_Gray_Btn"
      type={type ? type : "button"}
      onClick={onClick}
    >
      <p className="btn_text">{btnText}</p>
    </button>
  );
};

export default Dark_Gray_Btn;
